import { FC } from 'react';

import { KnzComponentProps } from '../../types';

/**
 * 設問の期待値ブロック。
 * params: id（AnswerCode の expected から参照）/ sourceFile（由来のファイルパス）/ sourceSeq（由来の連番）
 *
 * これは研修設問のプレフィル用メタデータであり、記事本文としては**描画しない**（null）。
 * arguments / stdout は knz に書かず（D6-B3）、由来（sourceFile + sourceSeq）のみ保持する。
 * 実際の検証値は反映時に実行履歴から DB へコピーされる。
 */
export const Expected: FC<KnzComponentProps> = () => null;

export default Expected;
